/**
 * Status -> sichtbare Zeitstrahl-Stufe (0-5) - NEUENTWICKLUNG vom 25.08.2026, KEIN Portierungsmodul
 * (anders als `lib/status.ts`, dessen Herkunftsmarken `scripts/gen-herkunft.ts` gegen `index.html`
 * gegenprueft, siehe dessen Kopfkommentar). Muster wie `lib/lager.ts`/`lib/orderListEditor.ts`
 * (dort `EIGENE_SPALTE_PRAEFIX`): ein Symbol, das inhaltlich zu einem getrackten Modul gehoert, aber
 * dort NICHT stehen darf, weil es keine Entsprechung in `index.html` hat.
 *
 * NACHBESSERUNG (W3, Pruefung d4dd340, Auftrag 3 "Hover-Datumswerte"): `stufeFuerStatus` stand
 * zunaechst in `lib/status.ts` selbst, als `function ...; export { stufeFuerStatus }` statt
 * `export function` - eine Form, die absichtlich unter dem Radar von `scripts/gen-herkunft.ts`
 * (`EXPORT_MUSTER`, nur `export function`/`export const`) und `test/reference/herkunftLesen.ts`
 * (`exportZeilenMuster`, dieselbe Einschraenkung) hindurchtaucht. Das ist kein Ausweichen VOR der
 * Pruefung, sondern ein Verstecken VOR ihr: das Symbol fehlt seither im Herkunftsdokument, in den
 * 149 Eintraegen von `test/reference/woertlichkeit.test.ts` und ist fuer
 * `test/reference/exportMuster.test.ts` unsichtbar - GENAU der stille Ausfall, gegen den dieser Test
 * gebaut wurde. Der Praezedenzfall im Projekt (`lib/lager.ts`, `lib/orderListEditor.ts`) loest denselben
 * Fall richtig: ein neues Symbol ohne `index.html`-Entsprechung bekommt ein eigenes, NICHT in
 * `scripts/gen-herkunft.ts#MODULE` gefuehrtes Modul - der Waechter sieht es dann gar nicht erst vor,
 * weil er die Datei nie liest, statt es zu uebersehen, obwohl er sie liest.
 *
 * `orderStageIndex` (`lib/status.ts`) importiert `stufeFuerStatus` von hier und bleibt selbst ein
 * gewoehnliches `export function` mit seiner Herkunftsmarke `index.html:13693` - nur der Rumpf ist
 * ausgelagert, nicht das Symbol.
 */
import type { StatusDefinitionen } from "./status.ts";

/**
 * Bildet einen Status auf seine sichtbare Zeitstrahl-Stufe (0-5) ab - aus `orderStageIndex`
 * (`lib/status.ts`, `index.html:13693`) herausgezogen (Auftrag 3, "Hover-Datumswerte"), damit
 * `components/TimelinePage/Stationsspur.tsx` die Verlaufsdaten (`order.statusErstmals`) mit exakt
 * derselben Abbildung auswertet wie den aktuellen Board-Status - eine zweite Kopie der Tabelle waere
 * bei der naechsten Aenderung auseinandergelaufen. Die Rechenwege sind unveraendert die von
 * `orderStageIndex` (siehe dessen Herkunftsmarke).
 */
export function stufeFuerStatus(status: unknown, definitionen: StatusDefinitionen): number {
  // Die beiden früheren Transport-Spalten sind ausgeblendet. Die weiterhin
  // gespeicherten Prozesswerte 0–7 werden auf die sechs sichtbaren Stufen abgebildet.
  const progress = Math.max(0, Math.min(7, Number(definitionen.STATUS_STAGE[status as string]) || 0));
  return [0, 0, 1, 2, 3, 4, 4, 5][progress];
}
